// extracted by mini-css-extract-plugin
module.exports = {"title":"PastCard__title__G5zqV","content":"PastCard__content__Tp4cV"};